export default "__VITE_ASSET__D8by4jYU__"